import { openInNewTab } from './openInNewTab';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';

export function downloadAttachmentFromUrl(
    downloadURL: string,
    openInNewWindow: boolean,
    container?: HTMLElement,
    downloadFileName?: string
) {
    // As all versions of IE don't support the `download` attribute
    // on anchor tag so if its IE then we always open the downloadUrl
    // in new tab otherwise the user will be navigated away from OWA.
    if (openInNewWindow || isBrowserIE()) {
        openInNewTab(downloadURL);
    } else {
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = downloadURL;
        link.download = downloadFileName ? downloadFileName : '';

        /*
         * We are simulating a click event on a hidden anchor element to trigger download
         * However in Firefox the simulated click event does nothing the element is not in DOM tree
         * so we need to insert it in to the DOM tree
         * If caller specified a container element,
         * we insert the hidden anchor there to prevent losing focus
         * and trigger unintended behavior.
         */
        if (!container) {
            container =
                (document.activeElement && document.activeElement.parentElement) || document.body;
        }

        container.appendChild(link);
        link.click();
        container.removeChild(link);
    }
}
